import React, { FC, useCallback } from 'react';

import { Box, Icon } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants } from 'components/action-button';

import {
  IToggleViewButtonProps,
  VIEW_ICON_MAP,
  VIEW_MESSAGE_ID_MAP,
} from '../../toggle-view-button/types';
import { StoreLocatorViews } from '../../types';

export const ToggleViewButton: FC<IToggleViewButtonProps> = ({
  className,
  currentView,
  updateStoreLocatorView,
}) => {
  const { formatMessage } = useIntl();

  const handleToggleLocatorViewClick = useCallback(() => {
    const newView =
      currentView === StoreLocatorViews.LIST_VIEW
        ? StoreLocatorViews.MAP_VIEW
        : StoreLocatorViews.LIST_VIEW;
    updateStoreLocatorView(newView);
  }, [currentView, updateStoreLocatorView]);

  // display map option when they are on the list view
  return (
    <Box position="absolute" right="0.5rem" top="1rem" zIndex={String(Styles.zIndex.top)}>
      <ActionButton
        variant={ActionButtonVariants.BOX_SHADOW_INVERSE}
        startIcon={<Icon icon={VIEW_ICON_MAP[currentView]} color="primary" aria-hidden />}
        className={className}
        onClick={handleToggleLocatorViewClick}
        data-testid="toggle-view-button"
        onlyIcon
        skipLogEvent
      >
        {formatMessage({ id: VIEW_MESSAGE_ID_MAP[currentView] })}
      </ActionButton>
    </Box>
  );
};

export default ToggleViewButton;
